import React from 'react';
import Input from './Input'


function App() {
	return (
		<div>
			<div className='container'>
				<h1>Welcome to Weather app</h1>
                <Input/>
				
			</div>
		</div>
	);
}

export default App;
